<template>
  <el-dialog
    id="agencyShareBillDialog"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="this.$t('SeaExport.AgentIntoBills')"
    width="1000px"
    :close-on-click-modal="false"
  >
    <div
      v-show="showForm"
      style="display:flex;flex-direction:row"
    >
      <div style="flex-grow:1;display:flex;flex-direction:column">
        <el-form
          label-width="100px"
          label-position="left"
        >
          <el-form-item
            :label="$t('SeaExport.MainOffice')"
            class="custom"
          >
            <el-select
              v-model="billing.titleBranchId"
              :placeholder="$t('Message.PleaseSelect')"
              :clearable="false"
              size="mini"
              style="width:250px"
              :disabled="currentState==='normal'"
            >
              <el-option
                v-for="(item,index) in officeList"
                :key="index"
                :label="item.chineseName"
                :value="item.officeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.BillNo')"
            class="custom"
          >
            <el-input
              v-model="billing.billingNo"
              style="width:160px"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.BillType')"
            class="custom"
          >
            <el-input
              v-model="billingArDesc"
              style="width:160px"
              :disabled="true"
            />
          </el-form-item>
        </el-form>
        <div style="display:flex;flex-direction:row;padding:2px 0">
          <div style="width:65px;margin-right:5px">
            <span>{{ $t('Billing.billingJob_originalCurrency') }}</span>
          </div>
          <div style="width:120px;margin-right:5px">
            <span>{{ $t('Billing.billingJob_amountOfMoney') }}</span>
          </div>
          <div style="width:120px;margin-right:5px">
            <span>{{ $t('Billing.billing_exchangeRate') }}</span>
          </div>
          <div style="width:95px">
            <span>{{ $t('Billing.billingJob_billAndCurrency') }}</span>
          </div>
        </div>
        <div style="display:flex;flex-direction:row;padding:2px 0">
          <el-input
            v-model="billing.sourceCurrency1"
            :disabled="true"
            style="width:65px;margin-right:5px"
          />
          <el-input-number
            v-model="billing.amount1"
            :min="-999999999999"
            :max="999999999999"
            :precision="2"
            :disabled="true"
            controls-position="right"
            style="width:120px;margin-right:5px"
          />
          <num-input
            v-model="billing.sourceRate1"
            :min="0"
            :max="999999999999"
            :precision="8"
            :truncated-precision="sourceRate1Precision"
            :disabled="!sourceRateEnable.sourceRate1"
            style="width:120px;margin-right:5px"
            @change="calculateAmount"
          />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_Currency"
            :default-value="billing.currency"
            style="width:120px"
            :disabled="currentState==='normal'"
            @parentCallBack="currencyChangeEvent"
          />
        </div>
        <div style="display:flex;flex-direction:row;padding:2px 0">
          <el-input
            v-model="billing.sourceCurrency2"
            :disabled="true"
            style="width:65px;margin-right:5px"
          />
          <el-input-number
            v-model="billing.amount2"
            :min="-999999999999"
            :max="999999999999"
            :precision="2"
            :disabled="true"
            controls-position="right"
            style="width:120px;margin-right:5px"
          />
          <num-input
            v-model="billing.sourceRate2"
            :min="0"
            :max="999999999999"
            :precision="8"
            :truncated-precision="sourceRate2Precision"
            :disabled="!sourceRateEnable.sourceRate2"
            style="width:120px;margin-right:5px"
            @change="calculateAmount"
          />
          <div style="width:95px;margin-top: 8px">
            <span>{{ $t('Billing.billing_billAmount') }}</span>
          </div>
        </div>
        <div style="display:flex;flex-direction:row;padding:2px 0">
          <el-input
            v-model="billing.sourceCurrency3"
            :disabled="true"
            style="width:65px;margin-right:5px"
          />
          <el-input-number
            v-model="billing.amount3"
            :min="-999999999999"
            :max="999999999999"
            :precision="2"
            :disabled="true"
            controls-position="right"
            style="width:120px;margin-right:5px"
          />
          <num-input
            v-model="billing.sourceRate3"
            :min="0"
            :max="999999999999"
            :precision="8"
            :truncated-precision="sourceRate3Precision"
            :disabled="!sourceRateEnable.sourceRate3"
            style="width:120px;margin-right:5px"
            @change="calculateAmount"
          />
          <el-input-number
            v-model="billing.amount"
            controls-position="right"
            :min="-999999999999"
            :max="999999999999"
            style="width:120px"
            :precision="2"
            :disabled="true"
          />
        </div>
        <div style="display:flex;flex-direction:row;padding:2px 0">
          <div>
            <div style="display:flex;flex-direction:row;padding:2px 0">
              <span>{{ $t('SeaExport.CostGenerationMethod') }}：</span>
            </div>
            <div style="display:flex;flex-direction:row;padding:2px 0">
              <el-radio-group v-model="generateChargeGroup">
                <el-radio :label="0">{{ $t('SeaExport.SettlementInPriginalCurrency') }}</el-radio>
                <el-radio :label="1">{{ $t('SeaExport.SettlementInBillCurrency') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div style="margin-left:20px;">
            <div style="display:flex;flex-direction:row;padding:2px 0">
              <span>{{ $t('SeaExport.CostRateValue') }}：</span>
            </div>
            <div style="display:flex;flex-direction:row;padding:2px 0">
              <el-radio-group v-model="generateDateRate">
                <el-radio :label="0">{{ $t('SeaExport.ByBillingDate') }}</el-radio>
                <el-radio :label="1">{{ $t('SeaExport.ByBusinessDate') }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div style="width:10px;height:100%" />
      <div style="flex-grow:1;display:flex;flex-direction:column">
        <el-form
          label-width="90px"
          label-position="left"
        >
          <el-form-item
            :label="$t('SeaExport.AccountObject')"
            class="custom"
          >
            <cargo-advance-select
              v-if="viewSource==='SeaBooking'"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
              filterable
              :callback-params="{key:'accountId'}"
              callback-method-type="value"
              :default-value="billing.accountId||''"
              :disabled="currentState==='normal'"
              style="width:250px"
              @parentCallBack="p=>{billing.accountId=p.value}"
            />
            <cargo-advance-select
              v-else
              :select-type="selectTypeNames.static_data_Company"
              filterable
              :callback-params="{key:'accountId'}"
              callback-method-type="value"
              :default-value="billing.accountId||''"
              :disabled="currentState==='normal'"
              :static-options="cmpOverseaList"
              style="width:250px"
              @parentCallBack="p=>{billing.accountId=p.value}"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Creator')"
            class="custom"
          >
            <el-input
              v-model="txtInputByText"
              :disabled="true"
              style="width:100px"
            />
            <span>&nbsp;{{ $t('SeaExport.Percentage') }}&nbsp;</span>
            <el-input
              v-model="billing.percentage"
              style="width:60px"
              @change="percentageChangeHandler"
            />
            <span>%</span>
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.DateOfCreation')"
            class="custom"
          >
            <el-date-picker
              v-model="billing.inputDate"
              type="date"
              style="width:150px"
            />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.Remarks')"
            class="custom"
          >
            <el-input
              v-model="billing.remark"
              type="textarea"
              :disabled="currentState==='normal'"
              :rows="3"
              style="width:250px"
            />
          </el-form-item>

          <el-form-item
            v-if="showChargeFrom.visible"
            :label="$t('CargoMsg.Cargo_GenerateExpenseAmount')"
            class="custom"
          >
            <el-input-number
              v-model="showChargeFrom.chargeAmount"
              :min="-999999999999"
              :max="999999999999"
              :precision="3"
              controls-position="right"
              style="width:120px;margin-right:5px"
            />
          </el-form-item>
          <el-form-item
            v-if="showChargeFrom.visible"
            :label="$t('CargoMsg.Cargo_GenerateExpenseMode')"
            class="custom"
          >
            <div>
              <el-checkbox v-model="showChargeFrom.receivables" :label="$t('CargoMsg.Cargo_GenerateInReceivables')" @change="showChargeFromChange('receivables')">{{ $t('CargoMsg.Cargo_GenerateInReceivables') }}</el-checkbox>
              <el-checkbox v-model="showChargeFrom.pay" :label="$t('CargoMsg.Cargo_GenerateInPay')" @change="showChargeFromChange('pay')">{{ $t('CargoMsg.Cargo_GenerateInPay') }}</el-checkbox>
            </div>
            <div>
              <el-checkbox v-model="showChargeFrom.all" :label="$t('CargoMsg.Cargo_GenerateAll')" @change="showChargeFromChange('all')">{{ $t('CargoMsg.Cargo_GenerateAll') }}</el-checkbox>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      style="width:100%;text-align: center;"
      @click="showForm=!showForm"
    >
      <i
        v-show="showForm"
        class="el-icon-d-arrow-left el-icon--right"
        style="font-size: 20px; font-weight: bold; transform: rotate(90deg);"
      />
      <i
        v-show="!showForm"
        class="el-icon-d-arrow-right el-icon--right"
        style="font-size: 20px; font-weight: bold; transform: rotate(90deg);"
      />
    </div>
    <cargo-ag-grid
      config-module="130151"
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="billing.agentCharge"
      :style="{width:'100%',height:showForm?'300px':'553px'}"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div
      slot="footer"
      style="padding:10px;min-height: 40px"
    >
      <div style="float:left">
        <el-button
          type="primary"
          @click="chargeSchemaClickHandler"
        >{{ $t('SeaExport.ChangeSchema') }}</el-button>
        <el-button
          type="primary"
          @click="addChargeHandler"
        >{{ $t('SeaExport.AddBillCharge') }}</el-button>
        <el-button
          type="primary"
          @click="removeChargeHandler"
        >{{ $t('SeaExport.RemoveBillCharge') }}</el-button>
      </div>
      <div style="float:right">
        <el-button
          type="primary"
          :disabled="saveBtnEnabled"
          @click="submitHandler"
        >{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </div>

    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargePlanDialog.visible"
      :visible.sync="chargePlanDialog.visible"
      :lob="chargePlanDialog.lob"
      :is-sea="chargePlanDialog.isSea"
      :original-condition="chargePlanDialog.originalCondition"
      :charge-scheme-is-approved="chargePlanDialog.chargeSchemeIsApproved"
      :source="chargePlanDialog.source"
      :job="job"
      :location="location"
      @selectedSchemeHandler="selectedSchemeHandler"
    />
  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import { Billing } from '@/class/model/act/Billing'
import lodash from 'lodash'
import { User } from '@/class/model/sys/User'
import StrUtils from '@/utils/StrUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { getSeaExportJobByUuid } from '@/api/seaExport/seaExportJob'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import { Charge } from '@/class/model/act/Charge'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import ChargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import { AgentCharge } from '@/class/model/act/AgentCharge'
import { saveAgentBilling } from '@/api/clearing/billingNative'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import { getLoading } from '@/utils/utilBaseElement'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

const NumberUtils = require('@/utils/NumberUtils')

export const MAX_CURRENCY_NUM = 3

export default {
  name: 'AgencyShareBillDialog',
  components: {
    ChargeSchemeBatchDialog,

    CargoAdvanceSelect,
    NumInput
  },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    propBilling: { type: Object, required: false },
    isAddOrEdit: { type: Boolean, default: false }, // true  修改
    debitChargetaxRate: { type: Number, required: false },
    billingChargeDetail: { type: Array, required: false }, //  新建国外账单带入的费用明细
    propBillingChargeAccounts: { type: Array, required: false }, // 结算对象集合
    currentBillingBranchId: { type: Number, required: false }, //  当前账单所属分公司(业务详情-账单页签)
    departmentTeamUser: { type: Array, required: false }, // 同部门的人：佣金(淳宏)判断费用创建人同组
    viewSource: { type: String, default: '' }, // 页面请求发起方
    location: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      colArDataProvider: [], // 费用列表 收付列 下拉框数据源
      colPaymentTypeProvider: [], // 费用列表 预付到付 下拉框数据源
      currentSelectedAgentCharge: null, // 当前选中的代理分成账单费用
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        // 行背景色设置
        getRowStyle: function(params) {
          if (!params.node.data.receivable) {
            return { color: '#0000FF' }
          }
        },
        onRowClicked: this.onRowClicked
      },
      rowData: [],
      gridApi: null,
      showForm: true,
      chargePlanDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        isSea: false,
        lob: 'SE',
        source: 'agentBilling',
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      officeList: [], // 分公司list
      sourceRateEnable: {
        sourceRate1: true, // 第一行汇率是否可编辑，默认不可编辑
        sourceRate2: true, // 第二行汇率是否可编辑，默认不可编辑
        sourceRate3: true // 第三行汇率是否可编辑，默认不可编辑
      },
      colPaymentTypeVisible: false, // 费用列表上 paymentType 列是否显示
      billing: new Billing().fillDefaultValue().getData(),
      loading: false,
      showChargeFrom: {
        visible: false,
        chargeAmount: 0, // 生成费用金额
        receivables: true, // 生成应收
        pay: false, // 生成应付
        all: false // 生成应收应付
      },
      currentState: '', // 界面控件状态值
      txtInputByText: '', // 创建人名称
      billingArDesc: '', // 账单类型
      generateChargeGroup: 0,
      generateDateRate: 0,
      currencyAmountMapCache: {}, // 合计后各币种原始金额(包含正负号,正表示应收,负号表示应付)
      createCharges: [], // 记录账单新创建的费用
      updateCharges: [], // 记录账单被修改的的费用
      removedCharges: [], // 记录账单被移除的费用
      removedAgentCharges: [], // 记录账单被移除的代理分成费用
      currentViewCacheData: {
        customerSettlementAgentMap: new Map() // 结算对象关联的结算代理
      },
      saveBtnEnabled: false
    }
  },
  computed: {
    columnDefs() {
      const defs = [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'serialNumber',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            }
          }
        },
        {
          headerName: this.$t('SeaExport.IsPercentage'),
          field: 'percentage',
          width: 80,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-checkbox',
            valueChanged: (p) => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Receivable'),
          field: 'receivable',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-select',
            options: this.colArDataProvider,
            optionField: {
              labelFunc: (item) => {
                return item.label
              },
              value: 'data'
            },
            valueChanged: (p) => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.PaymentType'),
          field: 'paymentType',
          hide: !this.colPaymentTypeVisible,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'el-select',
            options: this.colPaymentTypeProvider,
            optionField: {
              labelFunc: (item) => {
                return item.label
              },
              value: 'data'
            },
            valueChanged: (p) => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ChargeItem'),
          field: 'chargeItemId',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-advance-select',
            selectType: TYPE_NAMES.basic_data_ChargeItem,
            tagValue: 'itemId',
            tagName: 'zhName',
            valueChanged: (p) => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ChargeEnglishName'),
          field: 'chargeItemId',
          suppressMenu: true,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: { textConverter: (val) => {
              return !val ? '' : ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_ChargeItem,
                'itemId',
                val,
                'enName'
              )
            } }
          }
        },
        {
          headerName: this.$t('SeaExport.Currency'),
          field: 'currency',
          width: 110,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-advance-select',
            selectType: TYPE_NAMES.basic_data_Currency,
            tagValue: 'code',
            tagName: 'code',
            valueChanged: (p) => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Unit'),
          field: 'measure',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-advance-select',
            selectType: TYPE_NAMES.basic_data_ChargeUnit,
            tagValue: 'code',
            tagName: 'chineseName',
            valueChanged: (p) => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity2'),
          field: 'quantity',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            },
            valueChanged: (p) => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.UnitRate'),
          field: 'unitRate',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                return isNumber(val)
              }
            },
            valueChanged: (p) => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Amount'),
          field: 'amount',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'span',
            attrs: { textConverter: (val) => {
              return !val ? '' : ColumnUtils.number2ColumnLabelFunc(val)
            },
            classFunc: (params) => { return this.columnColorStyle(params.data) } }
          }
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remark',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: true,
            tag: 'cargo-cell-input'
          }
        }
      ]
      return defs
    },
    sourceRate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency1)
    },
    sourceRate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency2)
    },
    sourceRate3Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency3)
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      } else {
        this.saveBtnEnabled = false
      }
      this.$emit('update:visible', newVal)
    },
    'billing.amount': function(value) {
      this.doShowChargeDialog(false)
      this.showChargeDialog()
    }
  },
  created() {
    this.prepareData()
    if (this.visible) {
      this.innerVisible = true
    }
    const cmpList = getCacheListByKey(TYPE_NAMES.basic_data_Company)
    this.cmpOverseaList = cmpList.filter(p => p.overseaAgent && p.designationAgent && p.active)
  },
  beforeMount() {
    this.onShow()
  },
  methods: {
    // 鼠标单击行选中
    onRowClicked(event) {
      if (!event.data) return
      this.currentSelectedAgentCharge = null
      this.currentSelectedAgentCharge = event.data
    },
    onShow() {
      // 费用列表下拉框数据源
      this.colArDataProvider = [
        { data: true, label: 'DEBIT' },
        { data: false, label: 'CREDIT' }
      ]
      this.colPaymentTypeProvider = [
        { data: true, label: this.$t('SeaExport.ToPay') },
        { data: false, label: this.$t('SeaExport.PrePay') }
      ]

      this.billing = lodash.cloneDeep(this.propBilling)
      this.billingArDesc = this.arapComboBoxLabelEnFunc(this.billing.ar)
      this.colPaymentTypeVisible = parseInt(cache.config.get('CalculatePaymentType')) === 1
      if (this.billing && this.billing.uuid) {
        this.generateDateRate = this.billing.generateDateRate
        this.generateChargeGroup = this.billing.generateChargeGroup
      } else {
        this.generateDateRate = LocalStorageUtilsNew.getConfiguration('AGENT_BILLING_RATE_DATE') || 0
        this.generateChargeGroup = LocalStorageUtilsNew.getConfiguration('AGENT_BILLING_CHARGE_GROUP') || 0
      }
      this.commitProperties()
      this.showChargeDialog()
    },
    /**
     * 准备好数据
     */
    async prepareData() {
      await cache.load(cacheName.USER, cacheName.OFFICE_LIST, cacheName.CONFIG)
      this.user = cache.user
      this.officeList = cache.officeList
    },
    async commitProperties() {
      await this.billingChanged()
      const billAmount = this.billing.amount
      if (!this.billing.uuid) { // 新增情况下填充账单的其他币种信息。 编辑的时候以数据库存储的真是数据为准
        await this.fillChangedCurrency(true)
      } else {
        // 初始化汇率栏位是否可编辑，币种栏位有值，且和账单币种不一致时，才允许编辑
        for (let index = 1; index <= 3; index++) {
          this.sourceRateEnable['sourceRate' + index] = this.billing['sourceCurrency' + index] && this.billing['sourceCurrency' + index] !== this.billing.currency
        }
      }
      await this.calculateAmount()
      if (Number(billAmount) !== Number(this.billing.amount)) {
        // 由于费用生成方式默认是按原币种方式计算，若该账单是按账单币种结算计算的金额，则重新编辑会重新计算金额，所以这样处理
        this.billing.amount = billAmount
        this.generateChargeGroup = 1
      } else {
        if (!this.billing.uuid && parseInt(cache.config.get('CalculatePaymentType')) === 1) {
          this.generateChargeGroup = 1
        }
      }
    },
    async billingChanged() {
      const billing = this.billing
      const _billing = this.billing
      if (billing === null) {
        return
      }
      this.currentState = 'editing'
      if (_billing.invoiceRate > 0 || _billing.realClearingState > 0) this.currentState = 'normal'
      // Jira:778 代理分成账单产生的费用一旦本做到国外账单中、被审核、被核销、被确认、本分拆，则代理分成账单不允许进行编辑，防止数据不一致。
      else if (billing.agentSharedCharge && billing.agentSharedCharge.length > 0) {
        const charge = billing.agentSharedCharge[0]
        if (charge && (charge.billing || charge.billingAmount || charge.invoiceUuid || charge.verifiedAmount !== 0 || charge.chargeState > 0)) {
          this.currentState = 'normal'
        }
      }
      const creater = await User.getUserById(_billing.inputBy)
      if (creater === null) {
        this.txtInputByText = ''
      } else {
        this.txtInputByText = this.$store.getters.language === 'zh' ? creater.chineseName : creater.englishName
      }
    },
    async fillChangedCurrency(isFirstLoad = false) {
      const billing = this.billing
      if (billing == null) {
        return
      }
      const objCurrency = {}
      const objCurrencyAmount = {}
      for (const agentCharge of billing.agentCharge) {
        if (!objCurrency.hasOwnProperty(agentCharge.currency)) {
          if (agentCharge.currency === billing.currency) {
            objCurrency[agentCharge.currency] = 1.0
            if (isFirstLoad && !objCurrencyAmount.hasOwnProperty(agentCharge.currency + 'Amount')) {
              objCurrencyAmount[ agentCharge.currency + 'Amount' ] = await this.getAmountByBilling(billing, agentCharge.currency)
            }
          } else {
            if (isFirstLoad) {
              if (!objCurrencyAmount.hasOwnProperty(agentCharge.currency + 'Amount')) {
                objCurrencyAmount[ agentCharge.currency + 'Amount' ] = await this.getAmountByBilling(billing, agentCharge.currency)
              }
              objCurrency[agentCharge.currency] = await this.getRateByBilling(billing, agentCharge.currency)
            } else {
              const pageRate = await this.getRate(agentCharge.currency)
              objCurrency[agentCharge.currency] = pageRate === 0 ? await this.getRateByBilling(billing, agentCharge.currency) : pageRate
            }
          }
        }
      }

      // 先重置几个输入框
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        billing['sourceCurrency' + (i + 1)] = ''
        billing['amount' + (i + 1)] = 0
        this.sourceRateEnable['sourceRate' + (i + 1)] = false
        billing['sourceRate' + (i + 1)] = 0.0
      }

      let index = 0
      for (var c in objCurrency) {
        if (index < MAX_CURRENCY_NUM) {
          billing['sourceRate' + (index + 1)] = await this.getRate(c, objCurrency)
          const amount = objCurrencyAmount[c + 'Amount']
          billing['amount' + (index + 1)] = isNaN(amount) ? 0.0 : amount
          billing['sourceCurrency' + (index + 1)] = c
          this.sourceRateEnable['sourceRate' + (index + 1)] = c && c !== billing.currency
          index++
        }
      }
    },
    /**
     * 原币种金额  = 勾选的分成金额  × 分成比例  + 未勾选的金额
     * 账单金额 = 勾选费用金额总和  × 分成比例  + 未勾选的金额
     */
    async calculateAmount() {
      const billing = this.billing
      if (parseInt(cache.config.get('CalculatePaymentType')) === 1) {
        await this.calculateAmountNew()
        return
      }
      let percentage = parseFloat(billing.percentage)
      if (isNaN(percentage)) {
        percentage = 0
        billing.percentage = '0'
      } else if (percentage > 100) {
        percentage = 100
        billing.percentage = '100'
      }
      let billingAmount = 0.0 // 账单金额
      const currencyAmountMap = {} // 分币种金额合计
      if (billing.agentCharge && billing.agentCharge.length > 0) {
        for (const agentCharge of billing.agentCharge) {
          const chargeCurrency = agentCharge.currency
          if (!currencyAmountMap.hasOwnProperty(chargeCurrency)) {
            const arraryCharges = []
            arraryCharges.push(agentCharge)
            currencyAmountMap[chargeCurrency] = arraryCharges
          } else {
            const cuyCharges = currencyAmountMap[chargeCurrency]
            cuyCharges.push(agentCharge)
            currencyAmountMap[chargeCurrency] = cuyCharges
          }
          const rate = await this.getRate(agentCharge.currency)
          let chargeAmount = (agentCharge.receivable ? agentCharge.amount : -agentCharge.amount) * rate
          chargeAmount = RateUtil.getAmountByCurrency(chargeAmount, billing.currency)
          if (agentCharge.percentage) {
            // billingAmount += (chargeAmount * percentage) / 100
            billingAmount += RateUtil.getAmountByCurrency((chargeAmount * percentage) / 100, billing.currency)
          } else {
            billingAmount += chargeAmount
          }
          billingAmount = RateUtil.getAmountByCurrency(billingAmount, billing.currency)
        }
      }
      // 账单金额 = 勾选费用金额总和  × 分成比例  + 未勾选的金额
      billing.amount = ChargeUtils.getRoundingValue(Math.abs(billingAmount))
      billing.ar = billingAmount > 0
      this.billingArDesc = this.arapComboBoxLabelEnFunc(billing.ar)
      // 计算原币种金额  = 勾选的分成金额  × 分成比例  + 未勾选的金额
      this.fillViewCurrencyAmount(currencyAmountMap, percentage)
    },

    /**
     * //CARGO-1455 代理分成账单问题
     * 账单金额 = 勾选费用金额总和  × 分成比例  + 未勾选的金额
     * 【账单金额】根据原币种金额和账单币种即当前汇率，折算出金额
     */
    async calculateAmountNew() {
      const billing = this.billing
      let percentage = parseFloat(this.billing.percentage)
      if (isNaN(percentage)) {
        percentage = 0
        billing.percentage = '0'
      } else if (percentage > 100) {
        percentage = 100
        billing.percentage = '100'
      }
      let billingAmount = 0.0 // 账单金额
      const currencyAmountMap = {} // 分币种金额合计
      let isPercentage = false // 判断代理账单费用是否勾选分成，勾选任意一条则走分成计算的公式
      if (this.billing.agentCharge && this.billing.agentCharge.length > 0) {
        for (const agentCharge of this.billing.agentCharge) {
          const chargeCurrency = agentCharge.currency
          if (!currencyAmountMap.hasOwnProperty(chargeCurrency)) {
            const arraryCharges = []
            arraryCharges.push(agentCharge)
            currencyAmountMap[chargeCurrency] = arraryCharges
          } else {
            const cuyCharges = currencyAmountMap[chargeCurrency]
            cuyCharges.push(agentCharge)
            currencyAmountMap[chargeCurrency] = cuyCharges
          }
          if (agentCharge.percentage && !isPercentage) isPercentage = true
        }
      }

      // 计算原币种金额
      this.fillViewCurrencyAmountNew(currencyAmountMap, percentage, isPercentage)

      //  计算账单金额
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency' + (i + 1)]
        const rate = await this.getRate(sourceCurrency)
        let chargeAmount = this.currencyAmountMapCache.hasOwnProperty(sourceCurrency) ? this.currencyAmountMapCache[sourceCurrency] : 0
        chargeAmount = RateUtil.getAmountByCurrency(chargeAmount, billing.currency)
        // billingAmount += chargeAmount * rate
        billingAmount += RateUtil.getAmountByCurrency(chargeAmount * rate, billing.currency)
        billingAmount = RateUtil.getAmountByCurrency(billingAmount, billing.currency)
      }
      billing.amount = ChargeUtils.getRoundingValue(Math.abs(billingAmount))
      if (isPercentage) {
        billing.ar = !(billingAmount > 0)
      } else {
        billing.ar = billingAmount > 0
      }
      this.billingArDesc = this.arapComboBoxLabelEnFunc(billing.ar)
    },

    /**
     * 计算原币种金额  = 勾选的分成金额  × 分成比例  + 未勾选的金额
     */
    fillViewCurrencyAmount(currencyAmountMap, percentage) {
      const billing = this.billing
      this.currencyAmountMapCache = {}
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency' + (i + 1)]
        if (StrUtils.isEmpty(sourceCurrency)) {
          return
        }
        const charges = currencyAmountMap[sourceCurrency]
        let currencyAmount = 0.0 // 币种金额
        for (const agentCharge of charges) {
          if (agentCharge.percentage) {
            currencyAmount += ((agentCharge.receivable ? agentCharge.amount : -agentCharge.amount) * percentage) / 100
          } else {
            currencyAmount += agentCharge.receivable ? agentCharge.amount : -agentCharge.amount
          }
        }

        billing['amount' + (i + 1)] = ChargeUtils.getRoundingValue(Math.abs(currencyAmount))

        if (!StrUtils.isEmpty(sourceCurrency)) {
          this.currencyAmountMapCache[sourceCurrency] = currencyAmount
        }
      }
    },
    /**
     * //CARGO-1455 代理分成账单问题
     * 计算原币种金额【分成】
     * 分成账单金额公式： 预付应收（DEBIT）-预付应付（CREDIT）-profit share【（预付应收+到付应收-预付应付-到付应付）*分成比例】 余额为正数：收支类型为CREDIT； 余额为负数： 收支类型则为DEBIT。
     * 不分成金额计算公式： 到付应收-到付应付+预付应付-预付应收  余额正数为Debit 负数为Credit
     * isPercentage 判断该批费用是否分成
     */
    fillViewCurrencyAmountNew(currencyAmountMap, percentage, isPercentage) {
      this.currencyAmountMapCache = {}
      const billing = this.billing
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency' + (i + 1)]
        const charges = currencyAmountMap[sourceCurrency]
        let currencyAmount = 0.0 // 币种金额

        let preDebit = 0.0 // 预付应收
        let preCredit = 0.0 // 预付应付
        let toDebit = 0.0 // 到付应收
        let toCredit = 0.0 // 到付应付
        let notPercentage = 0.0 // 不分成金额

        if (isPercentage) {
          // 分成【包含部分分成】
          if (charges && charges.length > 0) {
            for (const agentCharge of charges) {
              if (agentCharge.paymentType) {
                // true 到付 false 预付 默认 false
                if (agentCharge.receivable) {
                  // 应收
                  toDebit += agentCharge.percentage ? agentCharge.amount : 0
                } else {
                  // 应付
                  toCredit += agentCharge.percentage ? agentCharge.amount : 0
                }
              } else {
                // 预付
                if (agentCharge.receivable) {
                  // 应收
                  preDebit += agentCharge.percentage ? agentCharge.amount : 0
                } else {
                  // 应付
                  preCredit += agentCharge.percentage ? agentCharge.amount : 0
                }
              }

              if (!agentCharge.percentage && isPercentage) {
                // 判断费用是否分层[部分不分成则累加]，全部不分成不需要进入此判断
                notPercentage += agentCharge.receivable ? agentCharge.amount : -agentCharge.amount
              }
            }
          }
          currencyAmount = preDebit - preCredit - ((preDebit + toDebit - preCredit - toCredit) * percentage) / 100 + notPercentage
        } else {
          // 不分成
          if (charges && charges.length > 0) {
            for (const agentCharge of charges) {
              if (agentCharge.paymentType) {
                // true 到付 false 预付 默认 false
                if (agentCharge.receivable) {
                  // 应收
                  toDebit += agentCharge.amount
                } else {
                  // 应付
                  toCredit += agentCharge.amount
                }
              } else {
                // 预付
                if (agentCharge.receivable) {
                  // 应收
                  preDebit += agentCharge.amount
                } else {
                  // 应付
                  preCredit += agentCharge.amount
                }
              }
            }
          }
          currencyAmount = toDebit - toCredit + preCredit - preDebit
        }

        billing['amount' + (i + 1)] = ChargeUtils.getRoundingValue(Math.abs(currencyAmount))
        if (!StrUtils.isEmpty(sourceCurrency)) {
          this.currencyAmountMapCache[sourceCurrency] = currencyAmount
        }
      }
    },
    /**
     * 根据币种获取页面币种的汇率
     * 若页面中已经存在汇率则直接取值,若没有则取系统维护汇率
     */
    async getRate(sourceCurrency, cacheMap = null) {
      const billing = this.billing
      let currencyRate = 0
      if (sourceCurrency) {
        const currency = this.billing.currency
        if (sourceCurrency === currency) {
          currencyRate = 1.0
        } else {
          for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
            const sourceCurrencyPage = cacheMap === null ? billing['sourceCurrency' + (i + 1)] : sourceCurrency
            if (sourceCurrencyPage === sourceCurrency) {
              currencyRate = cacheMap == null ? billing['sourceRate' + (i + 1)] : cacheMap[sourceCurrency]
              break
            } else if (billing !== null) {
              currencyRate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency, billing.inputDate, billing.branchId, null, true)
            }
          }
        }
      }
      return currencyRate
    },
    /**
     * 通过帐单上的汇率获取汇率,若没有,则从系统中获取汇率
     * @param billing
     * @param currency
     * @return
     */ async getRateByBilling(billing, currency) {
      let rate = 0.0
      if (billing === null || StrUtils.isEmpty(currency)) return rate
      for (let i = 1; i <= MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency ' + i]
        if (!StrUtils.isEmpty(sourceCurrency) && sourceCurrency === currency) {
          rate = Number(billing['sourceRate' + i])
          break
        }
      }
      return rate === 0.0
        ? await RateUtil.getForeignExchangeRateByDate(
          billing.currency,
          currency,
          billing.inputDate, billing.branchId
        )
        : rate
    },
    /**
     * 通过帐单上的币种获取,若没有,则返回0
     * @param billing
     * @param currency
     * @return
     */
    getAmountByBilling(billing, currency) {
      let amount = 0.0
      if (billing == null || StrUtils.isEmpty(currency)) return amount
      for (let i = 1; i <= MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = String(billing['sourceCurrency' + i])
        if (!StrUtils.isEmpty(sourceCurrency) && sourceCurrency === currency) {
          amount = Number(billing['amount' + i])
          break
        }
      }
      return amount
    },
    // 账单币种修改事件 ddlCurrency_changeHandler
    async currencyChangeEvent(obj = null) {
      const billing = this.billing
      if (obj) {
        billing.currency = obj.value
      }
      const localCurrency = this.currentBillingBranchId > 0 ? RateUtil.localCurrencyByOfficeId(this.currentBillingBranchId) : RateUtil.localCurrencyByOffice()
      billing.rate = await RateUtil.getForeignExchangeRateSafely(
        localCurrency,
        billing.currency,
        billing.inputDate, this.currentBillingBranchId > 0 ? this.currentBillingBranchId : this.$store.getters.currentOfficeId
      )
      await this.fillRate(billing.currency)
      await this.calculateAmount()
    },
    async fillRate(currency) {
      const billing = this.billing
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency' + (i + 1)]
        if (StrUtils.isEmpty(sourceCurrency)) {
          continue
        }

        let rate = 1.0
        if (sourceCurrency === currency) {
          this.sourceRateEnable['sourceRate' + (i + 1)] = false
        } else {
          this.sourceRateEnable['sourceRate' + (i + 1)] = true
          rate = await RateUtil.getForeignExchangeRateByDate(
            currency,
            sourceCurrency,
            billing.inputDate, billing.branchId,
            null,
            true
          )
        }
        billing['sourceRate' + (i + 1)] = rate
      }
    },
    // 分成比例修改
    percentageChangeHandler() {
      this.calculateAmount()
    },
    // 列编辑修改事件 (gridEditSaveHandler)
    async onCellChange(params) {
      const agentCharge = params.data
      if (!agentCharge) {
        return
      }
      switch (params.field) {
        case 'percentage':
          await this.calculateAmount()
          break
        case 'currency':
          agentCharge.rate = await this.getRate(agentCharge.currency)
          await this.fillChangedCurrency()
          // CARGO-29270，代理分成账单生成费用的费用数据 没有按照规则走
          if (!isNaN(agentCharge.quantity) && !isNaN(agentCharge.unitRate) && RateUtil.useAmountCarryRule()) {
            agentCharge.amount = ChargeUtils.getRoundingValue(RateUtil.getAmountByCurrency(agentCharge.quantity * agentCharge.unitRate, agentCharge.currency))
            this.gridApi.refreshCells({ force: true })
          }
          await this.calculateAmount()
          break
        case 'measure': // 等同 type
          agentCharge.type = agentCharge.measure
          await this.updateQuantity(agentCharge)
          agentCharge.quantity = NumberUtils.ToFixed2(agentCharge.quantity, 3)
          // agentCharge.amount = NumberUtils.ToFixed2(agentCharge.quantity * agentCharge.unitRate, 2)
          agentCharge.amount = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(agentCharge.quantity * agentCharge.unitRate, agentCharge.currency), 2)
          this.gridApi.refreshCells({ force: true })
          await this.calculateAmount()
          break
        case 'receivable':
        case 'unitRate':
        case 'quantity':
        case 'paymentType':
          agentCharge.quantity = Number(ChargeUtils.ToFixed(agentCharge.quantity, 3))
          // agentCharge.amount = ChargeUtils.getRoundingValue(
          //   agentCharge.quantity * agentCharge.unitRate
          // )
          agentCharge.amount = ChargeUtils.getRoundingValue(RateUtil.getAmountByCurrency(agentCharge.quantity * agentCharge.unitRate, agentCharge.currency))
          this.gridApi.refreshCells({ force: true })
          await this.calculateAmount()
      }
    },
    /**
     * 单位发生变动时取数量处理函数
     * @param event
     */
    async updateQuantity(agentCharge) {
      if (!agentCharge || !agentCharge.jobUuid || !agentCharge.type) {
        return
      }
      // todo 是否有必要？？？ 获取费用上的 job && job上的seaEQ
      const job = await getSeaExportJobByUuid(agentCharge.jobUuid).then((res) =>
        res.data ? res.data : null
      )
      const jobClass = new SeaExportJob(job)
      await jobClass.getSeaEQ()
      agentCharge.quantity = await ChargeUtils.getAgentChargeQuantity(
        agentCharge,
        jobClass,
        null,
        parseInt(cache.config.get('GetHBLcWeight')) === 1
      )
    },
    arapComboBoxLabelEnFunc(value) {
      return value === true ? 'DEBIT' : 'CREDIT'
    },
    // 加入费用
    addChargeHandler() {
      const agentCharge = new AgentCharge().fillDefaultValue().getData()
      const _billing = this.billing
      agentCharge.billingUuid = this.billing.uuid
      agentCharge.jobUuid = this.billing.jobUuid
      agentCharge.currency = _billing.currency
      agentCharge.measure = ChargeMeasure.NML_CHARGE_MEASURE.code
      agentCharge.unitRate = 0
      agentCharge.quantity = 1
      agentCharge.amount = 0
      agentCharge.percentage = true
      agentCharge.inputBy = _billing.inputBy
      agentCharge.inputDate = _billing.inputDate
      agentCharge.rate = _billing.rate
      agentCharge.receivable = false
      this.fillCurrency(agentCharge.currency)
      this.billing.agentCharge.push(agentCharge)
      agentCharge.serialNumber = _billing.agentCharge.length // 序号，CARGO-5881，按照录入顺序排序
      this.showChargeDialog()
    },
    async fillCurrency(currency) {
      const billing = this.billing
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        const sourceCurrency = billing['sourceCurrency' + (i + 1)]
        if (
          StrUtils.isEmpty(sourceCurrency) &&
          !this.isContainsCurrency(currency)
        ) {
          let rate = 1.0
          if (currency === billing.currency) {
            this.sourceRateEnable['sourceRate' + (i + 1)] = false
          } else {
            rate = await RateUtil.getForeignExchangeRateByDate(
              billing.currency,
              currency,
              billing.inputDate, billing.branchId
            )
          }
          billing['sourceRate' + (i + 1)] = rate
          billing['sourceCurrency' + (i + 1)] = currency
          break
        }
      }
    },
    /**
     * 页面上是否已经包含了币种sourceCurrency
     */
    isContainsCurrency(currency) {
      const billing = this.billing
      for (let i = 0; i < MAX_CURRENCY_NUM; i++) {
        const c = billing['sourceCurrency' + (i + 1)]
        if (c === currency) {
          return true
        }
      }
      return false
    },
    // 移除费用
    async removeChargeHandler() {
      if (!this.currentSelectedAgentCharge) {
        this.$message.info(this.$t('Message.PleaseSelectTheCostToRemove'))
        return
      }
      const opCharge = this.currentSelectedAgentCharge
      const serialNumber = opCharge.serialNumber
      const index = this.billing.agentCharge.findIndex(
        (p) => p === opCharge
      )
      if (index > -1) {
        this.billing.agentCharge.splice(index, 1)
        // 移除db 中已有的费用
        if (!StrUtils.isEmpty(opCharge.uuid)) {
          this.removedAgentCharges.push(opCharge)
        }
        this.currentSelectedAgentCharge = null
        this.gridApi.clearFocusedCell() // 取消选中
      }
      this.refreshSerialNumber(serialNumber)
      await this.fillChangedCurrency()
      await this.calculateAmount()
    },
    /**
     * 序号,递减
     */
    refreshSerialNumber(serialNumber) {
      for (const detail of this.billing.agentCharge) {
        if (detail.serialNumber > serialNumber) {
          detail.serialNumber = detail.serialNumber - 1
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    // 费用方案
    async chargeSchemaClickHandler() {
      // 需要依据业务类型分别后去job
      /* 调整原因：
           原逻辑如下，目的是为了根据billing.jobUUid获取job
                 // 需要 job的信息 job && job上的seaEQ -
                const job = await getSeaExportJobByUuid(
                  this.billing.jobUuid
                ).then((res) => (res.data ? res.data : null))
                const jobClass = new SeaExportJob(this.job)
                jobClass.getSeaEQ()
           现调整逻辑：
                账单关联job依赖 调用方传递。
                注:财务审核获取job详情的具体逻辑请参见：FinanceDetailHP.getAndSetJobDetail
      */

      // 移除job 上的 其他属性 避免 json 的循环依赖
      const jobCopy = { ... this.job }
      if (jobCopy.hasOwnProperty('containerUsages')) {
        delete jobCopy.containerUsages
      }
      if (jobCopy.hasOwnProperty('containers')) {
        delete jobCopy.containers
      }
      this.billing.job = jobCopy

      this.chargePlanDialog.isSea = this.job.lob === 'SE' || this.job.lob === 'SI'
      this.chargePlanDialog.lob = this.job.lob
      this.chargePlanDialog.chargeSchemeIsApproved =
        Number(cache.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.chargePlanDialog.visible = true
    },

    // 费用方案 -选择费用后事件
    async selectedSchemeHandler(schemeDetails) {
      // 移除job 上的 其他属性 避免 json 的循环依赖
      const jobCopy = { ... this.job }
      if (jobCopy.hasOwnProperty('containerUsages')) {
        delete jobCopy.containerUsages
      }
      if (jobCopy.hasOwnProperty('containers')) {
        delete jobCopy.containers
      }
      this.billing.job = jobCopy
      await ChargeUtils.applyChargeSchemeForAgentCharge(this.billing, schemeDetails)
      await this.fillChangedCurrency()
      await this.calculateAmount()
      await this.showChargeDialog()
    },
    showChargeFromChange(field) {
      switch (field) {
        case 'receivables':
          this.showChargeFrom.receivables = true
          this.showChargeFrom.pay = false
          this.showChargeFrom.all = false
          break
        case 'pay':
          this.showChargeFrom.receivables = false
          this.showChargeFrom.pay = true
          this.showChargeFrom.all = false
          break
        case 'all':
          this.showChargeFrom.receivables = false
          this.showChargeFrom.pay = false
          this.showChargeFrom.all = true
          break
      }
    },
    async addSCharge(_billing, editAdd = false) {
      if (!_billing.uuid || editAdd) {
        _billing.specialAmount = 0
        if (this.showChargeFrom.visible) {
          if (this.showChargeFrom.receivables) {
            this.createCharges.push(await this.createAgentSharedCharge(_billing, 5, true, true))
            this.createCharges.push(await this.createAgentSharedCharge(_billing, 5, true, false))
          }
          if (this.showChargeFrom.pay) {
            this.createCharges.push(await this.createAgentSharedCharge(_billing, 5, false, true))
            this.createCharges.push(await this.createAgentSharedCharge(_billing, 5, false, false))
          }
          if (this.showChargeFrom.all) {
            this.createCharges.push(await this.createAgentSharedCharge(_billing, 5, false, true))
            this.createCharges.push(await this.createAgentSharedCharge(_billing, 5, true, true))
          }
          _billing.specialAmount = this.showChargeFrom.chargeAmount // 记录生成对应费用
        }
      }
    },
    async addCharge(_billing, currencyItem, editAdd = false) {
      // 按原币种生成费用
      if (this.generateChargeGroup === 0) {
        if (!StrUtils.isEmpty(_billing.sourceCurrency1)) {
          if (StrUtils.isEmpty(_billing.uuid) || !this.checkChargeCurrency(_billing, _billing.sourceCurrency1) || editAdd) {
            const charge1 = await this.createAgentSharedCharge(_billing, 1, this.currencyAmountMapCache[_billing.sourceCurrency1] >= 0)
            if (charge1.amount && Number(charge1.amount) !== 0) this.createCharges.push(charge1)
          }
          if (_billing.amount1) {
            currencyItem[_billing.sourceCurrency1] = _billing.sourceCurrency1
          }
        }
        if (!StrUtils.isEmpty(_billing.sourceCurrency2)) {
          if (StrUtils.isEmpty(_billing.uuid) || !this.checkChargeCurrency(_billing, _billing.sourceCurrency2) || editAdd) {
            const charge2 = await this.createAgentSharedCharge(_billing, 2, this.currencyAmountMapCache[_billing.sourceCurrency2] >= 0)
            if (charge2.amount && Number(charge2.amount) !== 0) this.createCharges.push(charge2)
          }
          if (_billing.amount2 !== 0) {
            currencyItem[_billing.sourceCurrency2] = _billing.sourceCurrency2
          }
        }
        if (!StrUtils.isEmpty(_billing.sourceCurrency3)) {
          if (StrUtils.isEmpty(_billing.uuid) || !this.checkChargeCurrency(_billing, _billing.sourceCurrency3) || editAdd) {
            const charge3 = await this.createAgentSharedCharge(_billing, 3, this.currencyAmountMapCache[_billing.sourceCurrency3] >= 0)
            if (charge3.amount && Number(charge3.amount) !== 0) this.createCharges.push(charge3)
          }
          if (_billing.amount3 !== 0) {
            currencyItem[_billing.sourceCurrency3] = _billing.sourceCurrency3
          }
        }
      } else {
        // 按账单币种生成费用
        if (StrUtils.isEmpty(_billing.uuid) || !this.checkChargeCurrency(_billing, _billing.currency) || editAdd) {
          const chargeDefalut = await this.createAgentSharedCharge(_billing, 4, _billing.ar)
          this.createCharges.push(chargeDefalut)
        }
        currencyItem[_billing.currency] = _billing.currency
      }
    },
    // 保存
    async submitHandler() {
      this.saveBtnEnabled = true
      this.loading = getLoading()
      this.createCharges = []
      this.updateCharges = []
      this.removedCharges = []
      const _billing = this.billing
      if (!this.validate()) {
        this.saveBtnEnabled = false
        this.loading.close()
        return
      }
      if (StrUtils.isEmpty(_billing.uuid)) {
        // 账单所属分公司
        _billing.branchId = this.currentBillingBranchId > 0 ? this.currentBillingBranchId : this.$store.getters.currentOfficeId
      }
      _billing.settlementAgentId = _billing.accountId
      const currencyItem = {}
      // 生成费用
      await this.addCharge(_billing, currencyItem, false)
      await this.addSCharge(_billing, false)
      // 账单编辑
      await this.editCharge(_billing, currencyItem)
      // 排除掉金额为0的费用
      if (this.createCharges) {
        this.createCharges = this.createCharges.filter(data => data.amount && data.amount !== 0)
      }
      // 代理分成账单 关联的 费用
      _billing.createCharges = this.createCharges
      _billing.updateCharges = this.updateCharges
      _billing.removedCharges = this.removedCharges
      // 代理分成费用
      _billing.removedAgentCharges = this.removedAgentCharges
      _billing.location = this.location
      _billing.generateChargeGroup = this.generateChargeGroup
      _billing.generateDateRate = this.generateDateRate
      // 调用api 后台保存
      if (_billing.revoked && ((_billing.createCharges && _billing.createCharges.length > 0) || (_billing.updateCharges && _billing.updateCharges.length > 0))) {
        _billing.revoked = false
      }
      saveAgentBilling(_billing).then(() => {
        this.$emit('agentSaveSuccessHandler')
        LocalStorageUtilsNew.setConfiguration('AGENT_BILLING_RATE_DATE', this.generateDateRate)
        LocalStorageUtilsNew.setConfiguration('AGENT_BILLING_CHARGE_GROUP', this.generateChargeGroup)
        this.innerVisible = false
      }).catch(() => {
        this.saveBtnEnabled = false
      }).finally(() => {
        setTimeout(() => {
          this.loading.close()
        }, 1000)
      })
    },
    async editCharge(_billing, currencyItem) {
      let charge = {}
      if (!StrUtils.isEmpty(_billing.uuid)) {
        const generateDate = this.getGenerateRateDate(_billing)
        // 如果是 showChargeFrom.chargeAmount 生成的费用修改 或者 还原 都走删除新增
        if (this.showChargeFrom.chargeAmount > 0 || _billing.specialAmount > 0) {
          this.removedCharges = [..._billing.agentSharedCharge]
          await this.addSCharge(_billing, true)
          // 生成费用
          await this.addCharge(_billing, currencyItem, true)
        } else {
          const localCurrency = this.currentBillingBranchId > 0 ? RateUtil.localCurrencyByOfficeId(this.currentBillingBranchId) : RateUtil.localCurrencyByOffice()
          const branchId = this.currentBillingBranchId > 0 ? this.currentBillingBranchId : this.$store.getters.currentOfficeId
          const charges = [..._billing.agentSharedCharge]
          for (let i = charges.length - 1; i >= 0; i--) {
            charge = charges[i]
            if (_billing.accountId !== charge.accountId) {
              charge.accountId = _billing.accountId
              // 获取开票抬头
              await ChargeColumnUtil.getInvoiceTitle(charge)
              // 获取结算代理
              await ChargeColumnUtil.getSettlementByCompanyId(charge, this.currentViewCacheData)
            }
            // 币种移除了 删除对应的 费用
            if (!currencyItem.hasOwnProperty(charge.currency)) {
              this.removedCharges.push(charge)
              // 序号,递减  更新其他费用的序号
              const details = _billing.agentSharedCharge
              for (let j = details.length - 1; j >= 0; j--) {
                const detail = details[i]
                if (!this.removedCharges.includes(detail)) {
                  if (detail.receivable === charge.receivable && detail.serialNumber > charge.serialNumber) {
                    detail.serialNumber = detail.serialNumber - 1
                  }
                  this.updateCharges.push(detail)
                }
              }
            } else {
              if (this.generateChargeGroup === 0) {
                if (_billing.sourceCurrency1 === charge.currency) {
                  charge.currency = _billing.sourceCurrency1
                  charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(localCurrency, charge.currency, generateDate, branchId, null, true)
                  charge.amount = _billing.amount1
                  charge.excludingTaxAmount = _billing.amount1
                  charge.unitRate = charge.amount
                  if (this.currencyAmountMapCache.hasOwnProperty(_billing.sourceCurrency1)) {
                    charge.receivable = this.currencyAmountMapCache[_billing.sourceCurrency1] >= 0
                  }
                }
                if (_billing.sourceCurrency2 === charge.currency) {
                  charge.currency = _billing.sourceCurrency2
                  charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(localCurrency, charge.currency, generateDate, branchId)
                  charge.amount = _billing.amount2
                  charge.excludingTaxAmount = _billing.amount2
                  charge.unitRate = charge.amount
                  if (this.currencyAmountMapCache.hasOwnProperty(_billing.sourceCurrency2)) {
                    charge.receivable = this.currencyAmountMapCache[_billing.sourceCurrency2] >= 0
                  }
                }
                if (_billing.sourceCurrency3 === charge.currency) {
                  charge.currency = _billing.sourceCurrency3
                  charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(localCurrency, charge.currency, generateDate, branchId, null, true)
                  charge.amount = _billing.amount3
                  charge.excludingTaxAmount = _billing.amount3
                  charge.unitRate = charge.amount
                  if (this.currencyAmountMapCache.hasOwnProperty(_billing.sourceCurrency3)) {
                    charge.receivable = this.currencyAmountMapCache[_billing.sourceCurrency3] >= 0
                  }
                }
              } else {
                charge.currency = _billing.currency
                charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(localCurrency, _billing.currency, generateDate, branchId, null, true)
                charge.amount = _billing.amount
                charge.excludingTaxAmount = _billing.amount
                charge.unitRate = charge.amount
                charge.receivable = _billing.ar
              }
              this.updateCharges.push(charge)
            }
          }
        }
      }
    },
    /**
     * 创建代理生成费用
     */
    async createAgentSharedCharge(_billing, type, isAr, positive = true) {
      const charge = new Charge().fillDefaultValue().getData()
      const localCurrency = this.currentBillingBranchId > 0 ? RateUtil.localCurrencyByOfficeId(this.currentBillingBranchId) : RateUtil.localCurrencyByOffice()
      const branchId = this.currentBillingBranchId > 0 ? this.currentBillingBranchId : this.$store.getters.currentOfficeId
      charge.localCurrency = localCurrency
      const generateDate = this.getGenerateRateDate(_billing)
      switch (type) {
        case 1: {
          charge.currency = _billing.sourceCurrency1
          charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(
            localCurrency,
            charge.currency,
            generateDate, branchId,
            null,
            true
          )
          charge.amount = _billing.amount1
          charge.excludingTaxAmount = _billing.amount1
          break
        }
        case 2: {
          charge.currency = _billing.sourceCurrency2
          charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(
            localCurrency,
            charge.currency,
            generateDate, branchId,
            null,
            true
          )
          charge.amount = _billing.amount2
          charge.excludingTaxAmount = _billing.amount2
          break
        }
        case 3: {
          charge.currency = _billing.sourceCurrency3
          charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(
            localCurrency,
            charge.currency,
            generateDate, branchId,
            null,
            true
          )
          charge.amount = _billing.amount3
          charge.excludingTaxAmount = _billing.amount3
          break
        }
        case 5: {
          charge.currency = _billing.currency
          charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(
            localCurrency,
            _billing.currency,
            generateDate, branchId,
            null,
            true
          )
          if (positive) {
            charge.amount = this.showChargeFrom.chargeAmount
            charge.excludingTaxAmount = this.showChargeFrom.chargeAmount
          } else {
            charge.amount -= this.showChargeFrom.chargeAmount
            charge.excludingTaxAmount -= this.showChargeFrom.chargeAmount
          }
          break
        }
        default: {
          charge.currency = _billing.currency
          charge.exchangeRate = await RateUtil.getForeignExchangeRateByDate(
            localCurrency,
            _billing.currency,
            generateDate, branchId,
            null,
            true
          )
          charge.amount = _billing.amount
          charge.excludingTaxAmount = _billing.amount
        }
      }
      if (charge.amount !== 0) {
        // 账单所属分公司
        charge.branchId =
          this.currentBillingBranchId > 0
            ? this.currentBillingBranchId
            : this.$store.getters.currentOfficeId
        // HQ币种/汇率
        charge.hqCurrency = RateUtil.getHqCurrency(charge.branchId)
        charge.hqRate = await RateUtil.getForeignExchangeRateByDate(charge.hqCurrency, localCurrency, generateDate, charge.branchId, null, false)
        charge.jobUuid = this.job.uuid
        // 后端 处理  charge.businessDate = _billing.job.businessDate
        charge.billNo = _billing.billingNo
        charge.agentSharedBillingUuid = _billing.uuid
        charge.businessDate = this.job.businessDate
        charge.inputBy = _billing.inputBy
        charge.inputByDep = this.$store.getters.currentDeptId
        charge.inputDate = _billing.inputDate
        charge.receivable = isAr
        charge.unitRate = charge.amount
        charge.quantity = 1
        charge.measure = ChargeMeasure.NML_CHARGE_MEASURE.code
        charge.oversea = true
        const scaleCode = String(cache.config.get('OverSeaAgentChargeScaleCode'))

        const chargeItem = await ChargeItem.getChargeItemByScaleCode(scaleCode)
        charge.chargeItemId = chargeItem == null ? 60 : chargeItem.itemId
        charge.accountId = _billing.accountId
        if (charge.accountId > 0) {
          // 获取开票抬头
          await ChargeColumnUtil.getInvoiceTitle(charge)
          // 获取结算代理
          await ChargeColumnUtil.getSettlementByCompanyId(charge, this.currentViewCacheData)
        }
        // 序号:递加
        let lengthCost = 0 // 已有应收费用记录数
        let lengthSelling = 0 // 已有应付费用记录数
        for (const jobCharge of this.job.charges) {
          if (jobCharge.receivable) {
            lengthCost += 1
          } else {
            lengthSelling += 1
          }
        }
        if (charge.receivable) {
          // 应收
          charge.serialNumber = lengthCost
        } else {
          // 应付
          charge.serialNumber = lengthSelling
        }
      }
      return charge
    },
    /**
     * 检查是否需要新增费用
     */
    checkChargeCurrency(_billing, sourceCurrency) {
      const charges = _billing.agentSharedCharge
      if (charges && charges.length > 0) {
        for (let i = charges.length - 1; i >= 0; i--) {
          const charge = charges[i]
          if (charge.currency === sourceCurrency) {
            return true
          }
        }
      }
      return false
    },
    validate() {
      const billing = this.billing
      const percentage = parseFloat(billing.percentage)
      if (isNaN(percentage) || percentage <= 0) {
        this.$message.warning(this.$t('Message.EnterTheShareProportion'))
        return false
      } else if (StrUtils.isEmpty(billing.currency)) {
        this.$message.warning(this.$t('Message.PleaseSelectACurrency'))
        return false
      } else if (billing.accountId === 0) {
        this.$message.warning(this.$t('Message.PleaseEnterTheBillingObject'))
        return false
      } else if (!billing.inputDate) {
        this.$message.warning(this.$t('Message.PleaseEnterTheCreationDate'))
        return false
      } else if (billing.agentCharge === null || billing.agentCharge.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAddCosts'))
        return false
      }

      const currencys = []
      for (const agentCharge of billing.agentCharge) {
        if (agentCharge.chargeItemId === 0 || !agentCharge.chargeItemId) {
          this.$message.warning(this.$t('Message.PleaseEnterTheNameOfTheCosts'))
          return false
        } else if (agentCharge.quantity === 0) {
          this.$message.warning(this.$t('Message.PleaseEnterTheQuantityOfTheCosts'))
          return false
        } else if (isNaN(agentCharge.unitRate) || agentCharge.unitRate === 0) {
          this.$message.warning(this.$t('Message.PleaseEnterThePriceOfTheCosts'))
          return false
        }

        const chargeCurrency = agentCharge.currency
        // 汇总币种，不能超过3种
        if (!StrUtils.isEmpty(chargeCurrency) && currencys.indexOf(chargeCurrency) === -1) {
          if (currencys.length === MAX_CURRENCY_NUM) {
            this.$message.warning(this.$t('Billing.CostCannotExceed3Currencies'))
            return false
          }
          currencys.push(chargeCurrency)
        }
      }
      if (this.showChargeFrom.visible) {
        if (this.showChargeFrom.chargeAmount === 0 || isNaN(this.showChargeFrom.chargeAmount)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ChargeAmount'))
          return false
        }
      } else {
        if (billing.amount === 0 || isNaN(billing.amount)) {
          this.$message.warning(this.$t('Message.TheAmountOfBillCannotBeEqualTo'))
          return false
        }
      }
      return true
    },
    showChargeDialog() {
      // 账单金额为0 且里面存在不为0的费用
      if (this.billing.amount === 0 && this.billing.agentCharge && this.billing.agentCharge.length > 0) {
        this.doShowChargeDialog(true)
      }
    },
    doShowChargeDialog(visible) {
      this.showChargeFrom.chargeAmount = 0
      if (this.billing.specialAmount && this.billing.specialAmount > 0) {
        this.showChargeFrom.chargeAmount = this.billing.specialAmount
      }
      this.showChargeFrom.receivables = true
      this.showChargeFrom.pay = false
      this.showChargeFrom.all = false
      if (this.billing.agentSharedCharge) {
        let i = 0
        // 仅一条或两条费用 应收或应付
        for (const data of this.billing.agentSharedCharge) {
          if (data.receivable) {
            i += 1
          } else {
            i -= 1
          }
        }
        this.showChargeFrom.receivables = (i >= 1)
        this.showChargeFrom.pay = (i <= -1)
        this.showChargeFrom.all = (i === 0)
      }
      this.showChargeFrom.visible = visible
    },
    // 列字体颜色设置
    columnColorStyle(data) {
      if (!data) { return '' }

      if (data.receivable) {
        return ''
      }
      return 'data-blue'
    },
    getGenerateRateDate(billing) {
      if (!this.job || !billing) return null
      return this.generateDateRate === 1 && this.job.etd ? this.job.etd : billing.inputDate
    }
  }
}
</script>
<style lang='scss'>
  .data-blue{
    color: #0000ff;
  }
  #agencyShareBillDialog {
    .data-blue {
      input.el-input__inner {
        color: #0000ff;
      }
    }
  }
</style>
